// API Configuration
// For Coolify deployment, do not include port number
export const API_URL = process.env.REACT_APP_API_URL || 'https://backend.canada-ankara.com';

export default {
  API_URL,
};

